import React, { useState } from 'react'
import './Resources.css'
import Carousel from 'react-material-ui-carousel'
import { Paper } from '@material-ui/core'

export const Resources = () => {
  const items = [
    {
      name: 'Depression: More Than Feeling Down',
      description:
        'Depression is more than feeling sad. Its a common, long lasting illness the negatively affects how you feel, the way you think, and how you act.The persistent feeling of sadness or loss of interest that characterizes major depression can lead to a range of physical and behavioral symptoms. These may include changes in sleep, appetite, energy level, concentration, daily behavior, or self-esteem. Depression can also be associated with thoughts of suicide.',
    },
    {
      name: 'Anxiety is Normal.',
      description:
        'Anxiety becomes a mental health problem when thoughts or behavior become overwhelming, recur often, and are uncontrollable. Those with Anxiety respond to certain objects or situations with fear and dread. They can have physical reactions to those objects, like a rapid heartbeat and sweating.This can also alter your way of life. Its normal to feel anxious, and there is help to manage your anxiety. There is help out there. You are not alone.',
    },
    {
      name: 'Substance Use',
      description:
        'Did you know that addiction to drugs or alcohol is a mental illness? Substance use disorder changes normal desires and priorities. It changes normal behaviors and interferes with the ability to work, go to school, and to have good relationships with friends and family. Mental Health problems can sometimes lead to drug or alcohol use, as some people with a mental health issue may misuse these substances as a form of self-medication.',
    },
    {
      name: 'Eating Disorders',
      description:
        'These disorders involve extreme emotions, attitudes, and behaviors involving weight and food. The most common eating dosirders are: Anorexia, Bulimia, Binge Eating. There is a common misconception that symptoms must be severe in order to seek professional help, but any symptom is cause for concern and it is best to intervene early. When disordered eating has a negative impact on quality of life, its time to seek help.',
    },
  ]

  function Item(props) {
    return (
      <>
      <Paper>
        <h2 className='carousel__title'>{props.item.name}</h2>
        <p className='carousel__content'>{props.item.description}</p>
      </Paper>
      </>
    )
  }

  return (
    <Carousel className='carousel__container'>
      {items.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  )
}
